import { getRequest, patchRequest, postRequest } from "api/axiosClient";
import { AxiosRequestConfig } from "axios";
import type { RequestFormDraft } from "api/models/draftRequest.model";
import type {
  ConvertSystemDraftResponse,
  CreateSystemDraftResponse,
  SystemDraftDetailResponse,
  SystemDraftListResponse,
} from "api/response/systemDraft.response";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/quote-request/draft`;

const listDrafts = (config: AxiosRequestConfig = {}) => getRequest<SystemDraftListResponse>(`${baseURL}/`, config);

const createDraft = (payload: RequestFormDraft) => postRequest<CreateSystemDraftResponse>(`${baseURL}/`, payload);

const getDraftDetail = (draftId: string) => getRequest<SystemDraftDetailResponse>(`${baseURL}/${draftId}/`);

const patchDraft = (draftId: string, payload: Partial<RequestFormDraft>) =>
  patchRequest<void>(`${baseURL}/${draftId}/`, payload);

const convertDraft = (draftId: string, dryRun = false) =>
  postRequest<ConvertSystemDraftResponse>(`${baseURL}/${draftId}/create/`, dryRun ? { dry_run: true } : {});

export { listDrafts, createDraft, getDraftDetail, patchDraft, convertDraft };
